<script lang="ts" setup>
import Dialog from 'primevue/dialog'

defineOptions({ inheritAttrs: false })

withDefaults(defineProps<{ maximizable?: boolean }>(), { maximizable: true })
</script>

<template>
  <Dialog
    :maximizable="maximizable"
    v-bind="$attrs"
  >
    <template
      v-for="(_, name) in $slots"
      #[name]="slotProps"
    >
      <slot
        :name="name"
        v-bind="slotProps || {}"
      />
    </template>
  </Dialog>
</template>
